import React from "react";

interface PJBankLogoProps extends React.SVGProps<SVGSVGElement> {
    width?: string | number;
    height?: string | number;
    color?: string; // Cor principal do logotipo (para as letras e ícone)
}

export const PJBankLogo: React.FC<PJBankLogoProps> = ({
    width = 140,
    height = 70,
    color = "#008FB4", // Cor de preenchimento base (azul padrão do PJBank)
    ...props
}) => {
    // A cor principal será aplicada a todos os paths que eram azuis/coloridos.
    const primaryColor = color;

    // A cor branca é mantida para os vazados internos (os "buracos" nas letras).
    const internalColor = "#FFFFFF";

    return (
        <svg
            {...props}
            version="1.1"
            id="Layer_1"
            // ViewBox ajustado para remover o padding interno do SVG.
            // Original: 0 0 744 190. Novo: 14 14 730 176 (removendo margem esquerda e superior)
            viewBox="14 14 730 176"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
        >
            {/* Paths que definem as letras, agora com cor única (primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M125.983597,112.000000 
    C125.692001,87.513283 125.528206,63.523941 125.037704,39.541279 
    C124.866188,31.155212 123.654411,30.356850 115.585541,27.802113 
    C113.408539,27.112839 111.071289,25.514147 109.816971,23.652725 
    C107.857811,20.745335 109.693726,16.935127 112.822769,16.140219 
    C124.177948,13.255526 136.614609,21.877613 137.921951,33.597912 
    C138.291107,36.907162 138.688934,40.240063 138.677795,43.560795 
    C138.538727,85.046829 138.409576,126.533310 138.064621,168.017914 
    C137.994263,176.479111 128.000778,186.513245 118.865562,186.751434 
    C101.394943,187.207001 83.881638,187.400269 66.428062,186.681763 
    C53.420033,186.146255 46.104851,177.421997 46.062523,164.302368 
    C46.036205,156.145477 46.054104,147.960770 46.725555,139.844269 
    C46.960533,137.003860 48.531357,133.558823 50.645153,131.703598 
    C65.788483,118.412720 81.219727,105.449509 96.594955,92.424034 
    C97.723267,91.468163 99.102135,90.790848 100.411438,90.069160 
    C103.848824,88.174438 106.525871,89.568909 108.715317,92.250885 
    C110.994530,95.042809 109.999550,97.619415 107.631523,99.712509 
    C102.016609,104.675522 96.345840,109.578064 90.610893,114.401901 
    C82.324738,121.371605 74.107475,128.436493 65.578514,135.099396 
    C60.230667,139.277176 57.835136,144.446030 58.051796,151.051941 
    C58.199043,155.541504 58.014996,160.070175 58.553192,164.511810 
    C59.291298,170.603226 62.743736,173.993698 68.751015,174.065445 
    C84.399704,174.252365 100.056229,174.224609 115.702812,173.925888 
    C121.816330,173.809158 124.873009,170.693954 125.055519,164.460556 
    C125.562485,147.146164 125.699661,129.820938 125.983597,112.000000 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M93.488113,57.893959 
    C93.690758,50.495670 93.952881,43.502132 93.880684,36.512039 
    C93.814903,30.143759 90.533112,26.318428 84.177338,26.198965 
    C68.692818,25.907921 53.194088,25.881166 37.711315,26.218208 
    C31.048592,26.363247 27.006428,31.335135 27.006317,37.848011 
    C27.005623,78.664146 27.005791,119.480286 27.006145,160.296417 
    C27.006201,166.777695 30.412783,171.099121 36.723473,172.627579 
    C41.966385,173.897415 44.625706,176.770020 43.894196,180.373383 
    C43.195980,183.812714 38.970417,185.966949 34.160572,185.335678 
    C23.631351,183.953781 16.021639,176.318420 14.740475,165.632996 
    C14.325420,162.171265 14.155680,158.659775 14.159234,155.171326 
    C14.200310,114.855209 14.287990,74.539124 14.383950,34.223087 
    C14.405664,25.100449 21.519636,16.149307 30.688992,15.014813 
    C38.750622,14.017375 46.964840,13.968500 55.109905,13.997386 
    C67.082916,14.039845 79.097893,14.002496 91.011765,14.996582 
    C99.513901,15.705994 106.149811,23.169987 106.925072,31.771893 
    C107.625816,39.546936 107.633492,47.391644 107.762146,55.208672 
    C107.857597,61.008118 105.721184,66.196091 101.355385,69.871475 
    C85.571487,83.159286 69.608856,96.236252 53.615856,109.272797 
    C50.809761,111.560158 47.635101,112.287468 44.894444,108.744980 
    C42.126667,105.167427 43.254837,102.286774 46.351974,99.703903 
    C58.627350,89.466835 70.992332,79.334694 83.137131,68.945091 
    C86.865570,65.755486 89.997070,61.868084 93.488113,57.893959 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M217.893005,135.930206 
    C217.735931,139.239700 217.388718,142.070297 217.483231,144.886078 
    C217.765747,153.303711 206.600403,155.683502 201.296204,151.853333 
    C200.034149,150.942001 199.017441,148.938812 198.882629,147.353271 
    C198.389832,141.557602 198.143082,135.726990 198.117004,129.908142 
    C198.012558,106.606041 198.017700,83.303421 198.000931,60.000973 
    C197.996689,54.114899 201.251312,50.689224 207.023636,50.785187 
    C221.656448,51.028465 236.361771,50.589870 250.899094,51.930859 
    C267.661926,53.477131 277.968475,64.783295 279.751709,81.200066 
    C281.531342,97.583397 273.319946,111.144669 258.032532,117.095009 
    C247.590118,121.159508 236.603806,121.434334 225.626587,121.757690 
    C223.323074,121.825546 221.015869,121.767555 217.904800,121.767555 
    C217.904800,126.570511 217.904800,131.007523 217.893005,135.930206 
M218.242264,93.408424 
    C218.242264,95.843765 218.242264,98.279099 218.242264,101.037247 
    C223.165710,101.037247 227.466354,101.184006 231.752747,100.999367 
    C236.882507,100.778389 242.072098,100.682976 247.105804,99.795761 
    C254.424500,98.505798 259.824738,91.871956 260.099121,84.766579 
    C260.353485,78.178490 254.648804,67.966606 248.919678,67.468178 
    C238.924500,66.598610 228.799088,67.226028 218.242416,67.226028 
    C218.242416,75.903091 218.242416,84.168159 218.242264,93.408424 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M367.291260,144.503922 
    C367.237518,116.733551 367.210266,89.416084 367.196716,62.098606 
    C367.196136,60.934776 367.277039,59.766117 367.397736,58.607807 
    C368.125122,51.626930 368.700043,50.979816 375.643738,50.946434 
    C389.301056,50.880768 402.970947,50.640053 416.610992,51.141655 
    C421.977173,51.338993 427.574188,52.603252 432.554077,54.635960 
    C450.029999,61.769356 451.915070,85.202469 436.222382,97.184311 
    C435.339905,97.858109 434.412292,98.472801 433.089081,99.410141 
    C435.764099,101.001686 437.947388,102.473061 440.276337,103.658218 
    C454.869873,111.084572 454.860870,130.782211 447.372803,140.023651 
    C441.486267,147.288574 433.912170,151.856628 424.212067,151.974670 
    C408.059814,152.171234 391.906708,152.485962 375.754883,152.439072 
    C368.443207,152.417847 368.404724,152.043182 367.291260,144.503922 
M416.445007,107.871269 
    C404.868622,107.871269 393.292206,107.871269 381.530701,107.871269 
    C381.530701,118.966454 381.530701,130.350235 381.530701,142.622253 
    C396.073090,142.036362 410.334473,141.798965 424.522919,140.656372 
    C428.132874,140.365677 432.009338,137.769394 434.897614,135.242844 
    C441.999268,129.030655 441.403595,119.488304 433.971710,113.699532 
    C429.121918,109.921982 423.661957,107.688812 416.445007,107.871269 
M397.489136,60.147343 
    C392.218536,60.147343 386.947968,60.147343 381.561218,60.147343 
    C381.561218,71.645821 381.561218,82.707787 381.561218,94.496529 
    C394.173279,93.978706 406.492157,93.949692 418.709473,92.821114 
    C428.561462,91.911049 433.643585,85.022881 433.177216,75.245171 
    C432.791290,67.153648 426.328156,61.388756 416.944946,60.898586 
    C410.794830,60.577316 404.636841,60.406204 397.489136,60.147343 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M656.223755,153.663696 
    C652.254456,152.986084 650.936707,150.750397 650.941101,147.240372 
    C650.980591,115.607727 650.976685,83.974976 650.938293,52.342323 
    C650.933472,48.397259 652.308960,45.991734 656.621887,45.814056 
    C660.858643,45.639523 663.342224,47.312450 663.497803,51.725887 
    C663.691223,57.213509 663.932678,62.703041 663.952942,68.192482 
    C664.012939,84.455124 663.974365,100.718132 663.974365,118.385597 
    C669.720093,112.573524 674.546692,107.637642 679.432861,102.761528 
    C686.268921,95.939552 693.137573,89.150040 700.021484,82.376282 
    C701.323914,81.094666 702.719971,79.898430 704.146790,78.755119 
    C707.259583,76.260750 710.841797,75.800560 713.662415,78.573929 
    C716.606506,81.468666 714.452637,84.662971 712.265137,86.931328 
    C706.721130,92.680290 700.893799,98.156479 695.164490,103.725998 
    C692.903870,105.923615 690.602051,108.078918 688.160278,110.404671 
    C695.591003,119.836388 702.898376,129.084732 710.169067,138.361862 
    C711.707397,140.324722 713.690613,142.206238 714.417786,144.463791 
    C715.175781,146.817215 715.727112,150.472107 714.472717,151.968445 
    C712.218872,154.656967 708.417969,154.605286 705.492065,152.143127 
    C703.604553,150.554840 702.084900,148.507446 700.503601,146.581131 
    C694.377686,139.118942 688.201660,131.694778 682.235901,124.105812 
    C679.661682,120.831139 677.353760,119.739937 674.429077,123.501602 
    C674.127563,123.889297 673.719727,124.212173 673.314148,124.498344 
    C666.349487,129.412445 662.756470,135.543182 663.745422,144.624695 
    C664.466736,151.248917 662.546814,152.693192 656.223755,153.663696 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M474.937561,148.104538 
    C467.109955,141.075363 465.515900,132.492859 468.297211,123.259827 
    C470.913605,114.574310 477.477081,108.804085 486.269989,107.943558 
    C497.258575,106.868156 508.425568,107.599564 519.515564,107.599304 
    C520.789978,107.599281 522.064392,107.908714 523.344482,108.075409 
    C524.438049,97.711334 516.888000,88.896271 505.485962,88.190033 
    C499.472931,87.817581 493.339478,89.256828 487.271271,89.970406 
    C484.801788,90.260803 482.320892,91.273605 479.919952,91.071098 
    C477.953491,90.905251 474.461823,89.350174 474.498657,88.540794 
    C474.611115,86.070274 475.421600,82.614166 477.203430,81.459236 
    C480.423401,79.372162 484.490814,77.805969 488.299042,77.573509 
    C496.745483,77.057922 505.302032,76.933052 513.719116,77.694252 
    C525.211731,78.733589 534.173401,87.779671 534.814819,99.395256 
    C535.676453,114.999443 535.655151,130.658295 535.755249,146.295334 
    C535.789429,151.626694 533.507141,153.769913 529.052185,153.664581 
    C523.964966,153.544296 523.980957,149.870514 523.979431,146.233246 
    C523.979187,145.638245 523.904053,145.043259 523.846375,144.196487 
    C508.298981,156.449280 492.256073,158.609741 474.937561,148.104538 
M497.476593,145.201614 
    C509.315857,144.573486 518.660645,138.010498 521.468323,128.351883 
    C523.581726,121.081665 522.516235,119.165009 515.339111,117.569183 
    C512.751892,116.993919 510.145721,116.395592 507.515930,116.140968 
    C500.015839,115.414780 492.531860,115.269272 485.710205,119.238243 
    C476.058350,124.853912 475.957733,136.719269 485.742645,142.049591 
    C488.968323,143.806778 492.943115,144.188721 497.476593,145.201614 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M341.922791,98.000061 
    C341.772125,106.655373 342.117126,114.856506 341.370483,122.957024 
    C339.483612,143.429016 326.824280,154.620331 306.194580,154.524734 
    C295.169739,154.473648 285.115479,151.840164 277.443573,143.137375 
    C273.545319,138.715302 272.835449,135.109390 275.507019,131.568436 
    C279.203766,126.668701 282.908478,125.925636 288.522919,129.159500 
    C291.113037,130.651398 293.524475,132.450134 296.053864,134.051483 
    C307.737457,141.448349 320.531281,135.052460 321.046722,121.355530 
    C321.822998,100.727081 322.391296,80.089737 322.870270,59.452049 
    C322.968628,55.213924 323.911041,51.916336 328.247650,50.401379 
    C332.231445,49.009670 338.128937,50.494457 340.483002,53.877773 
    C341.333313,55.099899 341.541229,56.960857 341.563446,58.537056 
    C341.746521,71.523834 341.816864,84.512192 341.922791,98.000061 
z"/>
            {/* Letras (cores azuis substituidas por primaryColor) */}
            <path fill={primaryColor} opacity="1.000000" stroke="none"
                d="
M558.994263,125.999954 
    C559.216431,111.527481 559.367371,97.553223 559.714050,83.583824 
    C559.795715,80.294449 559.933350,76.885826 564.908569,76.684036 
    C569.854492,76.483459 571.312988,79.168442 571.802368,83.256447 
    C571.898376,84.058243 572.054810,84.852798 572.183472,85.650993 
    C572.646912,85.613678 573.108398,85.715302 573.256531,85.544762 
    C581.700195,75.823387 592.858093,75.380692 604.439514,76.395180 
    C615.178101,77.335846 626.308228,87.658195 626.849670,98.399338 
    C627.628418,113.846878 627.694458,129.338547 627.694031,144.811371 
    C627.693970,148.685471 627.956970,153.693832 621.630188,153.759827 
    C618.342163,153.794113 616.129883,152.676407 615.961975,149.013885 
    C615.657288,142.367783 615.292236,135.724243 615.017212,129.076965 
    C614.700806,121.429596 614.345276,113.781380 614.200134,106.129868 
    C613.873352,88.908958 595.592651,83.658699 585.423584,88.636292 
    C577.733276,92.400536 572.308044,97.881104 572.237061,107.393890 
    C572.136475,120.870674 571.486267,134.342575 571.190491,147.819183 
    C571.113586,151.325836 570.094299,153.719696 566.159302,153.662140 
    C562.411316,153.607346 559.611084,152.242874 559.487061,147.956833 
    C559.280151,140.805771 559.154419,133.652359 558.994263,125.999954 
z"/>

            {/* Paths dos Vazados (Branco) */}
            <path fill={internalColor} opacity="1.000000" stroke="none"
                d="
M218.242340,92.920822 
    C218.242416,84.168159 218.242416,75.903091 218.242416,67.226028 
    C228.799088,67.226028 238.924500,66.598610 248.919678,67.468178 
    C254.648804,67.966606 260.353485,78.178490 260.099121,84.766579 
    C259.824738,91.871956 254.424500,98.505798 247.105804,99.795761 
    C242.072098,100.682976 236.882507,100.778389 231.752747,100.999367 
    C227.466354,101.184006 223.165710,101.037247 218.242264,101.037247 
    C218.242264,98.279099 218.242264,95.843765 218.242340,92.920822 
z"/>
            <path fill={internalColor} opacity="1.000000" stroke="none"
                d="
M416.913269,107.891167 
    C423.661957,107.688812 429.121918,109.921982 433.971710,113.699532 
    C441.403595,119.488304 441.999268,129.030655 434.897614,135.242844 
    C432.009338,137.769394 428.132874,140.365677 424.522919,140.656372 
    C410.334473,141.798965 396.073090,142.036362 381.530701,142.622253 
    C381.530701,130.350235 381.530701,118.966454 381.530701,107.871269 
    C393.292206,107.871269 404.868622,107.871269 416.913269,107.891167 
z"/>
            <path fill={internalColor} opacity="1.000000" stroke="none"
                d="
M397.985779,60.157593 
    C404.636841,60.406204 410.794830,60.577316 416.944946,60.898586 
    C426.328156,61.388756 432.791290,67.153648 433.177216,75.245171 
    C433.643585,85.022881 428.561462,91.911049 418.709473,92.821114 
    C406.492157,93.949692 394.173279,93.978706 381.561218,94.496529 
    C381.561218,82.707787 381.561218,71.645821 381.561218,60.147343 
    C386.947968,60.147343 392.218536,60.147343 397.985779,60.157593 
z"/>
            <path fill={internalColor} opacity="1.000000" stroke="none"
                d="
M497.026001,145.200562 
    C492.943115,144.188721 488.968323,143.806778 485.742645,142.049591 
    C475.957733,136.719269 476.058350,124.853912 485.710205,119.238243 
    C492.531860,115.269272 500.015839,115.414780 507.515930,116.140968 
    C510.145721,116.395592 512.751892,116.993919 515.339111,117.569183 
    C522.516235,119.165009 523.581726,121.081665 521.468323,128.351883 
    C518.660645,138.010498 509.315857,144.573486 497.026001,145.200562 
z"/>
        </svg>
    );
};